const { Component } = Shopware;

/**
 * @package services-settings
 */
Component.extend(
    'swag-migration-profile-shopware55-local-credential-form',
    'swag-migration-profile-shopware-local-credential-form',
    {},
);
